import { Investment } from "@api";
import { DashboardGainersAndLosersData } from "../components/Dashboard/DashboardGainersAndLosers/types";

const EXPECTED_NUMBER_OF_ITEMS = 4;

export const prepareGainersAndLosers = (
  gainerInvestments: Investment[] = [],
  loserInvestments: Investment[] = []
): DashboardGainersAndLosersData => {
  if (!gainerInvestments.length && !loserInvestments.length)
    return { gainers: [], losers: [] };

  const toItem = ({
    id,
    name,
    quote,
    type,
    isin,
    hasValidIsin,
    quoteProvider,
  }: Investment) => ({
    id,
    name,
    value: quote?.changePercentAbs ?? 0,
    type,
    isin,
    hasValidIsin,
    quoteProvider,
  });

  const gainers = gainerInvestments.map(toItem);
  const losers = loserInvestments.map(toItem);

  if (
    losers.length >= EXPECTED_NUMBER_OF_ITEMS &&
    gainers.length >= EXPECTED_NUMBER_OF_ITEMS
  ) {
    return {
      gainers: gainers.slice(0, EXPECTED_NUMBER_OF_ITEMS),
      losers: losers.slice(0, EXPECTED_NUMBER_OF_ITEMS),
    };
  }
  if (
    losers.length < EXPECTED_NUMBER_OF_ITEMS &&
    gainers.length < EXPECTED_NUMBER_OF_ITEMS
  ) {
    return {
      gainers,
      losers,
    };
  }

  if (losers.length < EXPECTED_NUMBER_OF_ITEMS) {
    const needed =
      EXPECTED_NUMBER_OF_ITEMS + (EXPECTED_NUMBER_OF_ITEMS - losers.length);
    return {
      gainers: gainers.slice(0, needed),
      losers,
    };
  }

  const needed =
    EXPECTED_NUMBER_OF_ITEMS + (EXPECTED_NUMBER_OF_ITEMS - gainers.length);
  return {
    losers: losers.slice(0, needed),
    gainers,
  };
};
